import { HIERARCHY_ROLES } from "../constants/hierarchyRoles";

const hasRole = (roles, role) => Array.isArray(roles) && roles.includes(role);

/** JWT visibility / layout role → dashboard persona (priority: lower number = default when multiple). */
export const KPI_DASHBOARD_VIEWS = [
  {
    id: "admin",
    personaId: "admin",
    jwtRole: HIERARCHY_ROLES.MANAGE_HIERARCHY_METADATA,
    labelKey: "GoalsAndKpi.dashboardView.admin.label",
    bannerClass: "admin",
    bannerIcon: "⚙",
    priority: 1,
    matchesRole: (roles) => hasRole(roles, HIERARCHY_ROLES.MANAGE_HIERARCHY_METADATA)
  },
  {
    id: "executive",
    personaId: "executive",
    jwtRole: HIERARCHY_ROLES.VIEW_CEO_DASHBOARD,
    labelKey: "GoalsAndKpi.dashboardView.executive.label",
    bannerClass: "executive",
    bannerIcon: "📊",
    priority: 2,
    matchesRole: (roles) => hasRole(roles, HIERARCHY_ROLES.VIEW_CEO_DASHBOARD)
  },
  {
    id: "depthead",
    personaId: "depthead",
    jwtRole: HIERARCHY_ROLES.VIEW_DEPARTMENT_HIERARCHY,
    labelKey: "GoalsAndKpi.dashboardView.depthead.label",
    bannerClass: "depthead",
    bannerIcon: "✅",
    priority: 3,
    matchesRole: (roles) => hasRole(roles, HIERARCHY_ROLES.VIEW_DEPARTMENT_HIERARCHY)
  },
  {
    id: "champion",
    personaId: "champion",
    jwtRole: HIERARCHY_ROLES.VIEW_CHAMPION_HIERARCHY,
    labelKey: "GoalsAndKpi.dashboardView.champion.label",
    bannerClass: "depthead",
    bannerIcon: "✅",
    priority: 4,
    matchesRole: (roles) => hasRole(roles, HIERARCHY_ROLES.VIEW_CHAMPION_HIERARCHY)
  },
  {
    id: "divisionhead",
    personaId: "divisionhead",
    jwtRole: HIERARCHY_ROLES.VIEW_DIVISION_HIERARCHY,
    labelKey: "GoalsAndKpi.dashboardView.divisionhead.label",
    bannerClass: "divisionhead",
    bannerIcon: "📋",
    priority: 5,
    matchesRole: (roles) => hasRole(roles, HIERARCHY_ROLES.VIEW_DIVISION_HIERARCHY)
  },
  {
    id: "taskowner",
    personaId: "taskowner",
    jwtRole: HIERARCHY_ROLES.VIEW_ASSIGNED_HIERARCHY,
    labelKey: "GoalsAndKpi.dashboardView.taskowner.label",
    bannerClass: "taskowner",
    bannerIcon: "🛠",
    priority: 6,
    matchesRole: (roles) => hasRole(roles, HIERARCHY_ROLES.VIEW_ASSIGNED_HIERARCHY)
  }
];

export const getAvailableDashboardViews = (roles) =>
  KPI_DASHBOARD_VIEWS.filter((view) => view.matchesRole(roles)).sort(
    (a, b) => a.priority - b.priority
  );

export const getDefaultDashboardViewId = (roles) =>
  getAvailableDashboardViews(roles)[0]?.id || "taskowner";

export const getDashboardViewById = (viewId) =>
  KPI_DASHBOARD_VIEWS.find((view) => view.id === viewId) || null;
